module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_03-bd883d3290895f652d0a850a44eb0c03.webp";